// extracted by mini-css-extract-plugin
module.exports = {"video":"Video-module--video--2iKhg"};